export const normalizeAngle = (angle) => ((angle % 360) + 360) % 360;

export function poolForMode(entries, mode) {
  const seen = new Set();
  return entries.filter((item) => {
    if ((mode !== 'mixed' && item.kind !== mode) || seen.has(item.text)) return false;
    seen.add(item.text);
    return true;
  });
}

export function nextWheelBatch(pool, previous = null, random = Math.random) {
  const seen = previous?.seen || new Set();
  const current = new Set(previous?.items.map(item => item.text));
  const groups = [
    pool.filter(item => !seen.has(item.text)),
    pool.filter(item => seen.has(item.text) && !current.has(item.text)),
    pool.filter(item => seen.has(item.text) && current.has(item.text)),
  ];
  for (const group of groups) {
    for (let i = group.length - 1; i > 0; i -= 1) {
      const j = Math.floor(random() * (i + 1));
      [group[i], group[j]] = [group[j], group[i]];
    }
  }
  const items = groups.flat().slice(0, 8);
  return { pool, items, seen: new Set([...seen, ...items.map(item => item.text)]) };
}

export function slicesForMode(entries, mode, random = Math.random) {
  return nextWheelBatch(poolForMode(entries, mode), null, random).items;
}

// Each label becomes horizontal and upright when its slice reaches the top pointer.
export const labelRotation = (index, count) => index * 360 / count;
export const LABEL_RADIUS = 145;

export function labelFits(bounds, fontSize, index, count) {
  const angle = -90 + index * 360 / count;
  const radians = angle * Math.PI / 180;
  const [anchorX, anchorY] = point(angle, LABEL_RADIUS);
  const rotation = labelRotation(index, count) * Math.PI / 180;
  return [bounds.x, bounds.x + bounds.width].every((x) => [bounds.y, bounds.y + bounds.height].every((y) => {
    const dx = anchorX - 200 + fontSize * (x * Math.cos(rotation) - y * Math.sin(rotation));
    const dy = anchorY - 200 + fontSize * (x * Math.sin(rotation) + y * Math.cos(rotation));
    const projection = dx * Math.cos(radians) + dy * Math.sin(radians);
    const difference = normalizeAngle(Math.atan2(dy, dx) * 180 / Math.PI - angle + 180) - 180;
    return Math.hypot(dx, dy) <= 179 && projection >= 52 && (count === 1 || Math.abs(difference) <= 180 / count - 2);
  }));
}

export function fitLabelSize(bounds, index, count) {
  for (let size = 88; size >= 10; size -= 1) {
    if (labelFits(bounds, size, index, count)) return size;
  }
  return 10;
}
export const rotationForSelection = (current, index, count) => current + 5 * 360 + normalizeAngle(-index * 360 / count - normalizeAngle(current));
export const indexAtPointer = (rotation, count) => Math.round(normalizeAngle(-rotation) / (360 / count)) % count;

export function point(angle, radius) {
  const radians = angle * Math.PI / 180;
  return [200 + radius * Math.cos(radians), 200 + radius * Math.sin(radians)];
}

export function segmentPath(index, count) {
  const angle = -90 + index * 360 / count;
  const half = 180 / count;
  const [x1, y1] = point(angle - half, 185);
  const [x2, y2] = point(angle + half, 185);
  return `M 200 200 L ${x1} ${y1} A 185 185 0 0 1 ${x2} ${y2} Z`;
}
